import { render, staticRenderFns } from "./CRCalendarView.vue?vue&type=template&id=4e8aad36&scoped=true"
import script from "./CRCalendarView.vue?vue&type=script&lang=js"
export * from "./CRCalendarView.vue?vue&type=script&lang=js"
import style0 from "./CRCalendarView.vue?vue&type=style&index=0&id=4e8aad36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8aad36",
  null
  
)

export default component.exports